import React from 'react'
import type { Editor as TiptapEditor, FocusPosition } from '@tiptap/react'
import { Editor } from '@paintscout/ui-business'
import type { StyleClasses } from '@paintscout/ui'
import type { EditorMethods } from '@paintscout/ui-business'
import type { TemplateTag } from '@paintscout/util/util'

// The inspector's Format-tab toolbar (#22203) replaces these. One-line revert: flip to true.
const ENABLE_LEGACY_TEXT_MENUS = false

export interface HtmlEditorProps {
  autofocus?: FocusPosition
  classes?: StyleClasses<any>
  hasColor?: boolean
  header?: boolean
  onChange?: (content: string) => void
  presetColors?: string[]
  tippyOptions?: any
  value?: string
  disableToolbar?: boolean
  templateTags?: TemplateTag[]
  onEditorFocus?: (editor: TiptapEditor) => void
  onEditorBlur?: (editor: TiptapEditor, event?: FocusEvent) => void
  /** Presentation-theme-derived typography (ENG-1438) — see `Editor`'s `contentStyles` prop. */
  contentStyles?: Record<string, any>
}

const HtmlEditor = React.forwardRef(function HtmlEditor(
  props: HtmlEditorProps,
  ref: React.ForwardedRef<EditorMethods>
) {
  const {
    autofocus,
    classes,
    hasColor,
    header = true,
    onChange,
    value,
    disableToolbar,
    templateTags,
    onEditorFocus,
    onEditorBlur,
    contentStyles
  } = props

  return (
    <Editor
      ref={ref}
      autofocus={autofocus}
      classes={classes}
      content={value || ''}
      debounce={false}
      inline
      bubbleMenuEnabled={ENABLE_LEGACY_TEXT_MENUS}
      floatingMenuEnabled={ENABLE_LEGACY_TEXT_MENUS}
      disableToolbar={disableToolbar}
      onChange={onChange}
      onEditorFocus={onEditorFocus}
      onEditorBlur={onEditorBlur}
      contentStyles={contentStyles}
      toolbar={{
        bold: true,
        italic: true,
        underline: true,
        color: hasColor,
        headings: header,
        lists: true,
        align: true,
        link: true,
        ...(templateTags?.length ? { template: { tags: templateTags } } : {})
      }}
    />
  )
})

export default HtmlEditor
